import { FloatingPortal } from '@floating-ui/react'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { HTML_ELEMENT_THEME_PROVIDER_ID } from '../../../../constants/html'
import { FloatingSelectContext } from '../FloatingSelectContext'

import * as styles from './FloatingSelectDropdown.module.css'

function FloatingSelectDropdown({
  children,
  className = styles.dropdown,
  context,
  floatingPortalId = HTML_ELEMENT_THEME_PROVIDER_ID,
  floatingStyles,
  getFloatingProps,
  isOpen,
  refs,
  ...restProps
}) {
  const { setFloating } = refs || EMPTY_OBJECT

  return isOpen ? (
    <FloatingPortal id={floatingPortalId}>
      <FloatingSelectContext value={context}>
        <div
          {...restProps}
          {...getFloatingProps()}
          className={className}
          ref={setFloating}
          style={floatingStyles}
        >
          {children}
        </div>
      </FloatingSelectContext>
    </FloatingPortal>
  ) : null
}

export default FloatingSelectDropdown
